import {verifiedFetch} from '@github-ui/verified-fetch'
import {useRef} from 'react'

/**
 * Hook to manage and persist the compact mode setting for repository lists.
 * @param compactMode The initial compact mode value.
 * @param preferenceKey The key to use for the FormData.
 */
export function useCompactModeSetting(compactMode: boolean, preferenceKey: string) {
  const savedCompactModeRef = useRef(compactMode)

  function updateCompactModeSetting(value: boolean) {
    if (savedCompactModeRef.current === value) {
      return
    }

    savedCompactModeRef.current = value

    const formData = new FormData()
    formData.set(preferenceKey, value.toString())
    verifiedFetch('/repos/preferences', {method: 'PUT', body: formData})
  }

  return {updateCompactModeSetting}
}
